// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadas_GetTemplatesByFranchisesInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /mensagens_programadas/get_templates_by_franchises
 *
 * Fetches WhatsApp message templates for the given franchise IDs.
 */
import { registerContract } from './validate'

export interface MensagensProgramadas_GetTemplatesByFranchisesInput {
franquia_ids: number[]
}

registerContract('MensagensProgramadas_GetTemplatesByFranchisesInput', {
  franquia_ids: { type: 'array',   required: true },
})
